module.exports = __webpack_public_path__ + "img/duck-tape.62a28aff.svg";